<template>
  <div>
    <template v-for="value in menuData">

      <el-submenu v-if="value.children" :index="setParse(value.id)" :key="value.id" @click="getUrl(value)">
        <template slot="title">
          <span slot="title">{{ value.title }}</span>
        </template>
        <MenuTree :menu-data="value.children" />
      </el-submenu>
      <el-menu-item v-else :index="setParse(value.id)" :key="value.id" @click="getUrl(value)">
        <span slot="title">{{ value.title }}</span>
      </el-menu-item>

    </template>
  </div>
</template>

<script>
import menuConfig from '@/components/header/menuconfig'
export default {
  name: 'MenuTree',
  props: ['menuData'],
  mounted () {
    // console.log(this.menuData.length)
  },
  methods: {
    setParse (val) {
      return val.toString()
    },
    getUrl (val) {
      if (val.index) {
        if (this.$route.query.subhomepage !== undefined) {
          window.open(val.href)
        } else {
          val.href !== undefined ? location.href = val.href : location.href = location.protocol + '//' + location.host
        }
      } else {
        if (val.backRouteId === -1) {
          if (val.href === '' || val.href === undefined) {
            return 'javascript:void(0)'
          } else {
          /* 处理慕课单点认证 */
            if (val.href.indexOf('chaoxing-mooc.chaoxing.com') > -1) {
              if (this.$cookie.get('wlymobilephone') === undefined || this.$cookie.get('wlymobilephone') === null) {
                this.$router.push({path: '/login', query: {redirect: this.$router.currentRoute.fullPath}})
              } else {
                window.open(process.env.BASE_API + '/api/communal/front/interface/mooc?departmentCode=' + this.$cookie.get('museumCode') + '&mobile=' + this.$cookie.get('wlymobilephone'))
              }
            } else {
              window.open(val.href)
            }
          }
        } else {
          /* 处理地图点击导航 */
          if (val.backRouteId === 113) {
            window.open(location.protocol + '//' + location.host + '/map.html?columnId=' + val.id)
          } else {
            if (val.href === '' || val.href === undefined) {
              let menuUrl = '/' + menuConfig[val.backRouteId]
              if (this.$route.query.subhomepage !== undefined) {
                this.$router.push({path: menuUrl, query: {columnId: val.id, subhomepage: this.$route.query.subhomepage}})
              } else {
                this.$router.push({path: menuUrl, query: {columnId: val.id}})
              }
            } else if (val.href !== '') {
              window.open(val.href)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-submenu__title span{
  font-size: 16px;
}
/deep/ .el-submenu__title i {
  color: #fff;
  display: none;
}
/deep/ .el-menu--collapse {
  width: 54px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/menu.vue